import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/shared/ui/tooltip";

export const DepositsHoverCard = ({
  uniqueDeposits,
  uniqueMultiplier,
}: {
  uniqueDeposits: number;
  uniqueMultiplier: number;
}) => {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger className="hover:underline">
          {uniqueDeposits}
        </TooltipTrigger>
        <TooltipContent>
          Уникальные депозиты: {uniqueDeposits} <br />
          Уникальныe X'ы: {uniqueMultiplier}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
